module.exports = __webpack_public_path__ + "img/messages-1.97c4f681.svg";